<template>
  <div v-if="vacancyProject" id="applicant-edit-tab-personal-data">
    <div class="vx-row">
      <div class="vx-col w-full flex flex-wrap flex-row">
        <DataInput
          v-model="vacancyProject.title"
          required
          class="w-full md:w-1/2 mt-4 pl-3 pr-3"
          label="Titel"
          name="title"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.company"
          type="model"
          class="w-full md:w-1/2 mt-4 pl-3 pr-3"
          label="Firma"
          name="company"
          model-label="
          name
          landwehrId"
          :select-label="el => el.name + ' ' + (el.landwehrId ? '- L1' : '')"
          gql-filter-type="objectFilter"
          gql-query="companies"
        />

        <div class="w-full mb-2 pl-3 pr-3 flex flex-wrap flex-row">
          <DataInput
            v-model="vacancyProject.vacancyAmount"
            type="number"
            class="lg:w-1/6 mt-4 pl-3 pr-3"
            label="Anzahl Positionen"
            name="vacancyAmount"
            @input="updateValue"
          />

          <DataInput
            v-model="vacancyProject.vacancyAmountOccupied"
            type="number"
            class="lg:w-1/6 mt-4 pl-3 pr-3"
            label="Positionen besetzt"
            name="vacancyAmountOccupied"
            @input="updateValue"
          />
        </div>

        <DataInput
          v-model="vacancyProject.projectState"
          required
          type="select"
          class="w-full md:w-1/5 lg:w-1/2 mt-4 pl-3 pr-3"
          :options="projectState"
          label="Status"
          name="projectState"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.closeReason"
          type="model"
          class="w-full md:w-1/5 lg:w-1/2 mt-4 pl-3 pr-3"
          label="abgeschlossen weil"
          name="closeReason"
          gql-query="vacancyCloseReasons"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.consultantID"
          :initial-value="vacancyProject.consultant"
          type="model"
          class="w-full md:w-1/5 lg:w-1/3 mt-4 pl-3 pr-3"
          label="Berater"
          name="consultant"
          model-label="
            firstName
            lastName"
          :select-label="el => el.firstName + ' ' + el.lastName"
          gql-query="consultantsPage"
          gql-single-query="consultant"
          gql-filter-type="objectFilter"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.userGroup"
          type="model"
          class="w-full md:w-1/5 lg:w-1/3 mt-4 pl-3 pr-3"
          label="Benutzergruppe"
          name="userGroup"
          gql-query="userGroups"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.projectStage"
          type="model"
          class="w-full md:w-1/5 lg:w-1/3 mt-4 pl-3 pr-3"
          label="Phase"
          name="projectStage"
          gql-query="vacancyPhases"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.contractDate"
          type="date"
          class="w-full md:w-1/3 mt-4 pl-3 pr-3"
          label="Vertrag Datum"
          name="contractDate"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.requestedAt"
          type="date"
          class="w-full md:w-1/3 mt-4 pl-3 pr-3"
          label="Angefordert am"
          name="requestedAt"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.closedAt"
          type="date"
          class="w-full md:w-1/3 mt-4 pl-3 pr-3"
          label="Abschluss am"
          name="closedAt"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.description"
          type="html"
          class="w-full mt-4 pl-3 pr-3"
          label="Beschreibung"
          name="description"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.skillJobTypeID"
          :initial-value="vacancyProject.skillJobType"
          type="model"
          class="w-full md:w-1/5 lg:w-1/3 mt-4 pl-3 pr-3"
          label="Berufsgruppe"
          name="skillJobType"
          gql-query="applicantSkillJobTypes"
          @input="updateValue"
        />

        <DataInput
          v-model="vacancyProject.occupationID"
          :initial-value="vacancyProject.occupation"
          type="model"
          class="w-full md:w-1/5 lg:w-1/3 mt-4 pl-3 pr-3"
          label="Beruf"
          name="occupation"
          gql-query="occupations"
          @input="updateValue"
        />
      </div>
    </div>
    <div style="text-align: right">
      <vs-button class="mt-3" @click="save()">Speichern</vs-button>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";
import projectState from "@/data/enums/ProjectState.js";
import editFormMixin from "@/mixins/editFormMixin.js";

export default {
  components: {
    DataInput
  },
  mixins: [
    editFormMixin({
      dataProp: "project",
      idFields: ["skillJobType", "occupation", "consultant"],
      legacyIDFields: ["projectStage", "closeReason", "company", "userGroup"]
    })
  ],
  props: {
    projectId: { type: String, required: true }
  },
  data() {
    return {
      projectState,
      fetchFailed: false
    };
  },
  apollo: {
    vacancyProject: {
      query: gql`
        query VacancyProject($id: ID!) {
          vacancyProject(id: $id) {
            id
            title
            consultant {
              id
              firstName
              lastName
            }
            company {
              id
              name
            }
            contractDate
            projectState
            description
            vacancyAmount
            vacancyAmountOccupied
            requestedAt
            closedAt
            skillJobType {
              id
              name
            }
            occupation {
              id
              name
            }
            userGroup {
              id
              name
            }
            projectStage {
              id
              name
            }
            closeReason {
              id
              name
            }
          }
        }
      `,
      result() {
        this.updateCurrent();
      },
      variables() {
        return {
          id: this.projectId
        };
      },
      fetchPolicy: "network-only"
    }
  },
  computed: {
    project: {
      get() {
        return this.vacancyProject;
      },
      // eslint-disable-next-line
      set(v) {
        this.save(false);
      }
    }
  },
  watch: {
    project: {
      deep: true,
      handler: function(v) {
        this.project = v;
      }
    }
  },
  methods: {
    updateValue() {
      this.project = this.vacancyProject;
    },
    // eslint-disable-next-line
    async persist(v = null) {
      let input = this.getInput();
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($id: ID!, $input: VacancyProjectInput!) {
              vacancyProjectUpdate(id: $id, input: $input) {
                id
              }
            }
          `,
          variables: {
            id: this.projectId,
            input
          }
        });

        this.reportSuccess(input);
      } catch (e) {
        this.reportUnhandledError(e);
      }
    }
  }
};
</script>
